import React, { useContext, useState } from 'react'
import { Container, Grid, IconButton, Paper, Typography } from '@mui/material'
import { ContextoGlobal, ContextoGlobalInterface } from '../../GlobalStates/ContextoGlobal'
import Button from '@mui/material/Button'
import SearchIcon from '@mui/icons-material/Search'
import CloseIcon from '@mui/icons-material/Close'
import DataTable, { DataTableCabecalhoInterface } from '../../DevComponents/DataTable'
import { useNavigate } from 'react-router-dom'
import BackEndAPI from '../../Services/BackEndAPI'
import { MensagemTipo } from '../../GlobalStates/MensagemState'
import { DateTime } from 'luxon'
import { DTFORMAT } from '../../Utils/ClsFormatacao'
import PesquisarTabela from '../../DevComponents/PesquisarTabela'
import { VeiculoInterface } from '../../ImportBackend/Interfaces/VeiculoInterfaces'
import ExibirJSONDev from '../../DevComponents/ExibirJSONDev'
import ClsExportDataTableCSV from '../../Utils/ClsExportDataTableCSV'
import ClsValidacao from '../../Utils/ClsValidacao'
import InputText from '../../DevComponents/InputText'

interface HistoricoLocalizacaoInterface {
  placa: string
  data: string | null
  latitude: string | null
  longitude: string | null
  municipio: string | null
  uf: string | null
  localizacao: string | null
}

const Cabecalho: Array<DataTableCabecalhoInterface> = [
  {
    campo: 'data',
    cabecalho: 'Data/Hora',
    alinhamento: 'left',
    format: (v: string) => v && v.length > 0 ? DateTime.fromMillis(parseInt(v)).toFormat(DTFORMAT.USUARIO_DATETIME) : ''
  },
  {
    campo: 'municipio',
    cabecalho: 'Município',
    alinhamento: 'left'
  },
  {
    campo: 'uf',
    cabecalho: 'UF',
    alinhamento: 'left'
  },
  {
    campo: 'localizacao',
    cabecalho: 'Localização',
    alinhamento: 'left'
  },
  {
    campo: 'latitude',
    cabecalho: 'Latitude',
    alinhamento: 'right'
  },
  {
    campo: 'longitude',
    cabecalho: 'Longitude',
    alinhamento: 'right'
  }
]

export default function HistoricoLocalizacao() {

  const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface
  const { mensagemState, setMensagemState } = contexto

  const navigate = useNavigate()

  const [dados, setDados] = useState({
    placa: '',
    inicio: DateTime.now().toFormat(DTFORMAT.BANCO),
    termino: DateTime.now().toFormat(DTFORMAT.BANCO),
    hrInicio: '00:00',
    hrTermino: '23:59'
  })

  const [erros, setErros] = useState({})

  const [rsHistorico, setRsHistorico] = useState<Array<HistoricoLocalizacaoInterface>>([])

  const clsApi = new BackEndAPI()

  const onGerarRelatorio = () => {

    if (validarDados()) {

      const query = `
      getHistoricoLocalizacao(
        placa: "${dados.placa.trim().toUpperCase()}",
        dtInicio: "${dados.inicio}",
        dtTermino: "${dados.termino}",
        hrInicio: "${dados.hrInicio}",
        hrTermino: "${dados.hrTermino}"
      ) {
        placa
        data
        latitude
        longitude
        municipio
        uf
        localizacao
      }
        `

      clsApi.query<Array<HistoricoLocalizacaoInterface>>(query, 'getHistoricoLocalizacao', 'Gerando relatório...', contexto).then(rs => {
        setRsHistorico(rs)
        if (rs.length === 0) {
          setMensagemState({
            ...mensagemState,
            titulo: 'Sem dados',
            exibir: true,
            mensagem: 'Nenhum registro encontrado para a placa informada.',
            tipo: MensagemTipo.Info,
            exibirBotao: true
          })
        }
      }).catch(() => {
        setMensagemState({
          ...mensagemState,
          titulo: 'Erro!',
          exibir: true,
          mensagem: 'Erro ao gerar relatório de localização.',
          tipo: MensagemTipo.Error,
          exibirBotao: true
        })
      })

    }

  }

  const downloadDados = () => {
    const downloadCSV: ClsExportDataTableCSV = new ClsExportDataTableCSV()

    downloadCSV.exportCSV('HistoricoLocalizacao - '.concat(dados.placa), rsHistorico, Cabecalho)
  }

  const validarDados = (): boolean => {

    let retorno: boolean = true
    let retornoData: boolean = true
    let retornoHora: boolean = true
    let erros: { [key: string]: string } = {}

    let clsValidacao = new ClsValidacao()

    retornoData = clsValidacao.eData('inicio', dados, erros, retornoData)
    retornoData = clsValidacao.eData('termino', dados, erros, retornoData)

    if (retornoData && dados.termino < dados.inicio) {
      erros['termino'] = 'A data de término deve ser maior ou igual à data de início.'
      retornoData = false
    }

    retornoHora = clsValidacao.eHorario('hrInicio', dados, erros, retornoHora)
    retornoHora = clsValidacao.eHorario('hrTermino', dados, erros, retornoHora)

    if (retornoHora && dados.hrTermino < dados.hrInicio) {
      erros['hrTermino'] = 'A hora de término deve ser maior ou igual à hora de início.'
      retornoHora = false
    }

    if (dados.placa.length !== 7) {
      erros['placa'] = 'A placa deve conter 7 caracteres.'
      retorno = false
    }

    retorno = clsValidacao.naoVazio('placa', dados, erros, retorno)

    setErros(erros)

    return retorno && retornoData && retornoHora

  }

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 5 }}>
        <Paper variant="outlined" sx={{ padding: 2 }}>
          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography component="h5" variant="h5" align="left">
                Histórico de Localização
                <Typography variant="body2" gutterBottom>
                  Consulte o histórico de posicionamento do veículo
                </Typography>
              </Typography>
              <IconButton onClick={() => navigate('/')}>
                <CloseIcon />
              </IconButton>
            </Grid>

            <Grid item xs={12}>

              <PesquisarTabela<VeiculoInterface>
                field='placa'
                fieldSet='placa'
                label='Placa Veiculo'
                dados={dados}
                setState={setDados}
                camposParaExibir={['placa', 'descricao']}
                campoQueryPesquisaID='placa'
                campoQueryPesquisa='pesquisa'
                camposRetornoQueryPesquisa='{idVeiculo, placa, descricao}'
                campoLabelQueryPesquisa='placa'
                nomeQueryPesquisa='getVeiculos'
                nomeQueryPesquisaID='getVeiculos'
                mensagemPesquisa='Procurando...'
                pesquisarTudoAoIniciar
                valorAtribuirLimpar={''}
                erros={erros}
              />

            </Grid>

            <Grid item xs={12} md={3}>
              <InputText
                textAlign='right'
                dados={dados}
                field='inicio'
                label='Data de Início'
                setState={setDados}
                erros={erros}
                tipo='date'
              />
            </Grid>

            <Grid item xs={12} md={3} sx={{ pl: { md: 1 } }}>
              <InputText
                textAlign='right'
                dados={dados}
                field='termino'
                label='Data de Término'
                setState={setDados}
                erros={erros}
                tipo='date'
              />
            </Grid>

            <Grid item xs={12} md={3} sx={{ pl: { md: 1 } }}>
              <InputText
                textAlign='right'
                dados={dados}
                field='hrInicio'
                label='Hora de Início'
                setState={setDados}
                erros={erros}
                mask='00:00'
              />
            </Grid>

            <Grid item xs={12} md={3} sx={{ pl: { md: 1 } }}>
              <InputText
                textAlign='right'
                dados={dados}
                field='hrTermino'
                label='Hora de Término'
                setState={setDados}
                erros={erros}
                mask='00:00'
              />
            </Grid>

            <Grid item xs={12} textAlign='right' sx={{ mt: 3, mb: 3, pl: { md: 1 } }}>
              <Button
                variant='contained'
                startIcon={<SearchIcon />}
                onClick={onGerarRelatorio}
              >
                Pesquisar
              </Button>
            </Grid>

            <Grid item xs={12} sx={{ mt: 3 }}>
              <DataTable
                dados={rsHistorico}
                cabecalho={Cabecalho}
                acoes={[]}
              />
            </Grid>

            <Grid item xs={12} textAlign='right' sx={{ mt: 2 }}>
              <Button
                variant='contained'
                startIcon={<SearchIcon />}
                onClick={() => downloadDados()}
                disabled={rsHistorico.length === 0}
              >
                Download
              </Button>
            </Grid>

          </Grid>
        </Paper>
      </Container >

      <ExibirJSONDev oque={['dados', dados, 'rsHistorico', rsHistorico]} />
    </>
  )
}
